// ink-component
import React from 'react';
import { ThemeProvider } from 'styled-components';
import getLegendComponent from '../../helpers/getLegendComponent';

import { LegendFormatType, SizeType } from '../../Progress';
import { ProgressLegendItemIcon, ProgressLegendItemLabel, ProgressLegendItemWrapper } from '../../styles';

export interface ProgressLegendItemProps {
  /** Legend item size can either be small or large */
  size?: SizeType;
  /** Legend icon color accepts valid ink color values */
  color?: string;
  /** Item label */
  label?: string;
  /** Numeric value of item */
  value?: any;
  /** Item value format */
  valueFormat?: LegendFormatType;
  /** Legend icon shape can either be square or circle */
  type?: string;
}

/**
 * @purpose Descriptive legend items for progress bars
 * @group Progress
 */
function ProgressLegendItem({ color, label, value, size, valueFormat, type, ...otherProps }: ProgressLegendItemProps) {
  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        size,
        color,
        type,
      })}
    >
      <ProgressLegendItemWrapper {...otherProps}>
        <ProgressLegendItemIcon />
        <ProgressLegendItemLabel>
          {label}{' '}
          {valueFormat && value !== undefined && value !== null && <>{getLegendComponent(value, valueFormat)}</>}
        </ProgressLegendItemLabel>
      </ProgressLegendItemWrapper>
    </ThemeProvider>
  );
}

ProgressLegendItem.defaultProps = {
  size: 'small',
  color: 'blue',
  label: '',
  value: 0,
  valueFormat: 'number',
  type: 'rectangle',
};

ProgressLegendItem.displayName = 'ProgressLegend.Item';

export default ProgressLegendItem;
